module.exports = __webpack_public_path__ + "img/app_img_m.3f45231f.jpg";